import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AppLayout from '../components/layout/AppLayout';
import LoginPage from '../pages/LoginPage';
import DashboardPage from '../pages/DashboardPage';
import AssetPage from '../pages/AssetPage';
import CommercialPage from '../pages/CommercialPage';
import FinancePage from '../pages/FinancePage';
import HRMPage from '../pages/HRMPage';
import { OfficePage } from '../pages/OfficePage';
import ProcurementPage from '../pages/ProcurementPage';
import ProductionPage from '../pages/ProductionPage';
import SubcontractPage from '../pages/SubcontractPage';
import MasterFilesPage from '../pages/MasterFilesPage';
import EmployeeManagement from '../pages/employee/EmployeeManagement';
import EmployeeAnalysis from '../pages/employee/EmployeeAnalysis';
import HRMDashboard from '../pages/employee/HRMDashboard';
import LeaveManagement from '../pages/employee/LeaveManagement';
import PayrollPage from '../pages/PayrollPage';
import PayrollDashboard from '../pages/Payroll/Dashboard';
import PayrollMasterFileMaintenance from '../pages/Payroll/MasterFileMaintenance';
import PayrollEmployeeSalary from '../pages/Payroll/EmployeeSalary';
import PayrollBatches from '../pages/Payroll/PayrollBatches';
import PayrollOvertime from '../pages/Payroll/Overtime';
import PayrollLoansAdvances from '../pages/Payroll/LoansAdvances';
import PayrollProcessing from '../pages/Payroll/PayrollProcessing';
import PayrollApproval from '../pages/Payroll/PayrollApproval';
import PayrollPayments from '../pages/Payroll/Payments';
import PayrollHeader from '../pages/Payroll/PayrollHeader';
import PayrollPayslips from '../pages/Payroll/Payslips';
import PayrollFinanceIntegration from '../pages/Payroll/FinanceIntegration';
import PayrollReports from '../pages/Payroll/Reports';
import PayrollUtilities from '../pages/Payroll/Utilities';
import PayrollText from '../pages/Payroll/PayrollText';
import PayrollTextCustom from '../pages/Payroll/PayrollTextCustom';
import PayrollSalarySummary from '../pages/Payroll/SalarySummary';
import TaxTable from '../pages/Payroll/TaxTable';

import UserManagement from '../pages/UserManagement';

import CFormPage from '../pages/Payroll/Reports/CFormPage';
import KFormPage from '../pages/Payroll/Reports/KFormPage';
import ProtectedRoute, { PublicRoute } from './ProtectedRoute';
import HolCaldendar from '../pages/HolydayCalendar/Calendar'

import AttendanceAdjustments from '../pages/Attendance/AttendanceAdjustments';
import AttendanceApproval from '../pages/Attendance/AttendanceApproval';

import LeaveHistory from '../pages/Leave/LeaveHistory';
import LeaveDashboard from '../pages/Leave/LeaveDashboard';
import LeaveAllocation from '../pages/Leave/LeaveAllocation';
import LeaveApproval from '../pages/Leave/LeaveApproval';
import LeaveAdjustments from '../pages/Leave/LeaveAdjustments';
import LeaveEarnings from '../pages/Leave/LeaveEarnings';
import LeaveTypes from '../pages/Leave/LeaveTypes';
import LeavePolicies from '../pages/Leave/LeavePolicies';
import LeaveRequest from '../pages/Leave/LeaveRequest';
import LeaveBalance from '../pages/Leave/LeaveBalance';
import MonthlyReport from '../pages/Reports/MonthlyReport';

import OtManagement from '../pages/Overtime/OtManagement'
import OTDetails from '../pages/Overtime/OTDetails'
import OTEntry from '../pages/Overtime/OTEntry';
import HrmOTDashboard from '../pages/Overtime/OTDashboard'


import LeaveDashboardReports from '../pages/Leave/LeaveDashboardReports';
import LeaveHolidayCalendar from '../pages/Leave/LeaveHolidayCalendar';
import LeaveApplicationBalance from '../pages/Leave/LeaveApplicationBalance';
import LeaveConfiguration from '../pages/Leave/LeaveConfiguration';

import OTDashboard from '../pages/Payroll/Overtime/dashboard';
import HrmSummaryPage from '../pages/Attendance/AttendanceSummaryDashboard';
import AttendanceSummary from '../pages/Attendance/AttendanceSummary';
import AttendanceDetails from '../pages/Attendance/AttendanceDetails';
import AAttendanceOverview  from '../pages/Attendance/AttendanceOverview';

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<PublicRoute><LoginPage /></PublicRoute>} />

      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <AppLayout>
              <Routes>
                <Route path="/dashboard" element={<DashboardPage />} />
                <Route path="/asset" element={<AssetPage />} />
                <Route path="/commercial" element={<CommercialPage />} />
                <Route path="/finance" element={<FinancePage />} />
                <Route path="/hrm" element={<HRMPage />} />
                <Route path="/hrm/attendence-summery" element={<HrmSummaryPage />} />
                <Route path="/hrm/attendance/details" element={<AttendanceSummary />} />
                <Route path="/hrm/attendance/attendance-details" element={<AttendanceDetails />} />
                <Route path="/hrm/attendance/attendance-overview" element={<AAttendanceOverview />} />
                <Route path="/hrm/employees" element={<EmployeeManagement />} />
                <Route path="/hrm/analysis" element={<EmployeeAnalysis />} />
                <Route path="/hrm/dashboard" element={<HRMDashboard />} />
                <Route path="/hrm/leave" element={<LeaveManagement />} />
                <Route path="/hrm/calendar" element={<HolCaldendar />} />
                <Route path="/hrm/payroll" element={<PayrollPage />} />
                <Route path="/hrm/monthly-report" element={<MonthlyReport />} />

                <Route path="/payroll" element={<Navigate to="/payroll/dashboard" replace />} />
                <Route path="/payroll/dashboard" element={<PayrollDashboard />} />
                <Route path="/payroll/master-file" element={<PayrollMasterFileMaintenance />} />
                <Route path="/payroll/employee-salary" element={<PayrollEmployeeSalary />} />
                <Route path="/payroll/batches" element={<PayrollBatches />} />
                <Route path="/payroll/overtime" element={<PayrollOvertime />} />
                <Route path="/payroll/overtime/otdashboard" element={<OTDashboard/>}/>
                <Route path="/payroll/loans-advances" element={<PayrollLoansAdvances />} />
                <Route path="/payroll/processing" element={<PayrollProcessing />} />
                <Route path="/payroll/approval" element={<PayrollApproval />} />
                <Route path="/payroll/payments" element={<PayrollPayments />} />
                <Route path="/payroll/header" element={<PayrollHeader />} />
                <Route path="/payroll/payslips" element={<PayrollPayslips />} />
                <Route path="/payroll/finance-integration" element={<PayrollFinanceIntegration />} />
                <Route path="/payroll/reports" element={<PayrollReports />} />
                <Route path="/payroll/utilities" element={<PayrollUtilities />} />
                <Route path="/payroll/c-form" element={<CFormPage  />} />
                <Route path="/payroll/k-form" element={<KFormPage  />} />
                <Route path="/payroll/payroll-text" element={<PayrollText />} />
                <Route path="/payroll/payroll-text-custom" element={<PayrollTextCustom />} />
                <Route path="/payroll/tax-table" element={<TaxTable />} />
                <Route path="/payroll/salary-summary" element={<PayrollSalarySummary />} />

                {/* Attendance Routes */}
                <Route path="/hrm/attendance/adjustments" element={<AttendanceAdjustments />} />
                <Route path="/hrm/attendance/approval" element={<AttendanceApproval />} />

                {/* Leave Routes */}
                <Route path="/hrm/leave/dashboard" element={<LeaveDashboard />} />
                <Route path="/hrm/leave/history" element={<LeaveHistory />} />

                {/* Leave Configuration with nested routes */}
                <Route path="/hrm/leave/types" element={<LeaveConfiguration />}>
                  <Route index element={<LeaveTypes />} />
                </Route>
                <Route path="/hrm/leave/policies" element={<LeaveConfiguration />}>
                  <Route index element={<LeavePolicies />} />
                </Route>
                <Route path="/hrm/leave/request" element={<LeaveApplicationBalance />}>
                  <Route index element={<LeaveRequest />} />
                </Route>
                <Route path="/hrm/leave/allocation" element={<LeaveApplicationBalance />}>
                  <Route index element={<LeaveAllocation />} />
                </Route>
                <Route path="/hrm/leave/approval" element={<LeaveApplicationBalance />}>
                  <Route index element={<LeaveApproval />} />
                </Route>
                <Route path="/hrm/leave/adjustments" element={<LeaveApplicationBalance />}>
                  <Route index element={<LeaveAdjustments />} />
                </Route>
                <Route path="/hrm/leave/earnings" element={<LeaveApplicationBalance />}>
                  <Route index element={<LeaveEarnings />} />
                </Route>
                <Route path="/hrm/leave/balance" element={<LeaveApplicationBalance />}>
                  <Route index element={<LeaveBalance />} />
                </Route>

                {/* Leave Child Routes */}
                <Route path="/hrm/leave/more/dashboard-reports" element={<LeaveDashboardReports />} />
                <Route path="/hrm/leave/more/holiday-calendar" element={<LeaveHolidayCalendar />} />
                <Route path="/hrm/leave/more/application-balance" element={<LeaveApplicationBalance />}>
                  <Route index element={<Navigate to="/hrm/leave/request" replace />} />
                </Route>
                <Route path="/hrm/leave/more/configuration" element={<LeaveConfiguration />}>
                  <Route index element={<Navigate to="/hrm/leave/types" replace />} />
                </Route>

                {/* Overtime Routes */}
                <Route path="/hrm/OtManagement" element={<OtManagement />} />
                <Route path="/hrm/overtime/details" element={<OTDetails />} />
                <Route path="/hrm/overtime/dashboard" element={<HrmOTDashboard />} />
                 <Route path="/hrm/overtime/entry" element={<OTEntry />} />

                <Route path="/office" element={<OfficePage />} />
                <Route path="/procurement" element={<ProcurementPage />} />
                <Route path="/production" element={<ProductionPage />} />
                <Route path="/subcontract" element={<SubcontractPage />} />
                <Route path="/user-management" element={<UserManagement />} />
                <Route path="/master-files" element={<MasterFilesPage />} />
                <Route path="/" element={<Navigate to="/dashboard" replace />} />
                <Route path="*" element={<Navigate to="/dashboard" replace />} />
              </Routes>
            </AppLayout>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}